import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountLayoutProposal, ApiResponse } from 'app/entities';
import { Account } from 'app/entities/account';
import { PagePost } from 'app/entities/page-post';
import { ShareLink } from 'app/entities/share-link';
import { ApiService } from 'app/services/api.service';
import { parse } from 'path';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends ApiService {
  getSettings() {
    return this.httpService.get(`/v1/clients/settings`, {});
  }

  getAccount() {
    return this.httpService.get(`/v1/clients/settings-account`, {}).pipe(map((res) => Account.parse(res.data) as Account));
  }

  updateAccount(account) {
    return this.httpService.post(`/v1/clients/settings-account`, account).pipe(map((res) => Account.parse(res.data) as Account));
  }

  updatePageSettings(data) {
    let formData = this.formDataFromObject(data);
    return this.httpService.post(`/v1/clients/page-settings`, formData).pipe(map((res) => Account.parse(res.data) as Account));
  }

  removePageSettingsImage(data) {
    return this.httpService.post(`/v1/clients/remove-page-settings-image/${data.id}`).pipe(map((res) => Account.parse(res.data) as Account));
  }

  uploadPageSettingsImages(data) {
    let formData = this.formDataFromObject(data);
    return this.httpService.post(`/v1/clients/page-settings-images`, formData).pipe(map((res) => Account.parse(res.data) as Account));
  }

  updateProposal(data) {
    let formData = this.formDataFromObject(data);
    return this.httpService.post(`/v1/clients/settings-proposal`, formData).pipe(map((res) => AccountLayoutProposal.parse(res.data) as AccountLayoutProposal));
  }

  deleteImageProposal(params) {
    return this.httpService.post(`/v1/clients/settings-proposal/image/delete`, params);
  }

  // Notification

  getNotificationPermissions() {
    return this.httpService.get(`/v1/clients/settings/notification`, {});
  }

  updateNotificationPermissions(permissions) {
    return this.httpService.post(`/v1/clients/settings/notification`, permissions);
  }

  updateCpfCnpj(cpfCnpj: string) {
    return this.httpService.post(`/v1/clients/settings/account/cpfOrCnpj`, { cpfCnpj });
  }

  skipStep(step) {
    return this.httpService.post(`/v1/clients/settings-skip-step`, { step_key: step }).pipe(map((res) => res.data as any));
  }

  // Share Links (Links de Compartilhamento)

  getShareLinks() {
    return this.httpService.get(`/v1/clients/share-links`, {}).pipe(map((res) => ShareLink.parse(res.data) as ShareLink[]));
  }

  createShareLink(title: string) {
    return this.httpService.post(`/v1/clients/share-links`, { title }).pipe(map((res) => ShareLink.parse(res.data) as ShareLink));
  }

  updateShareLink(id: number, title: string) {
    return this.httpService.put(`/v1/clients/share-links/${id}`, { title }).pipe(map((res) => ShareLink.parse(res.data) as ShareLink));
  }

  updateShareLinkStatus(id: number, active: boolean) {
    return this.httpService.post(`/v1/clients/share-links/${id}/status`, { active }).pipe(map((res) => ShareLink.parse(res.data) as ShareLink));
  }

  deleteShareLink(id: number) {
    return this.httpService.delete(`/v1/clients/share-links/${id}`);
  }

  getQrCode(url: string) {
    return this.httpService.get(`/v1/clients/page-settings-qrcode`, { url }).pipe(
      map((res) => res.data as { base64: string; filename: string; mime_type: string })
    );
  }

  // Page Banner (Minha Página)

  uploadBanner(file: File) {
    const formData = new FormData();
    formData.append('banner', file);
    return this.httpService.post(`/v1/clients/page-settings-banner`, formData).pipe(map((res) => Account.parse(res.data) as Account));
  }

  removeBanner() {
    return this.httpService.delete(`/v1/clients/page-settings-banner`).pipe(map((res) => Account.parse(res.data) as Account));
  }

  // Page Logo (Minha Página)

  uploadPageLogo(file: File) {
    const formData = new FormData();
    formData.append('logo', file);
    return this.httpService.post(`/v1/clients/page-settings-logo`, formData).pipe(map((res) => Account.parse(res.data) as Account));
  }

  removePageLogo() {
    return this.httpService.delete(`/v1/clients/page-settings-logo`).pipe(map((res) => Account.parse(res.data) as Account));
  }

  // Page Posts (Minha Página)

  getPosts() {
    return this.httpService.get(`/v1/clients/page-posts`, {}).pipe(map((res) => PagePost.parse(res.data) as PagePost[]));
  }

  storePost(data: { image?: File; title?: string; description?: string }) {
    const formData = this.formDataFromObject(data);
    return this.httpService.post(`/v1/clients/page-posts`, formData).pipe(map((res) => PagePost.parse(res.data) as PagePost));
  }

  updatePost(id: number, data: { image?: File; title?: string; description?: string }) {
    const formData = this.formDataFromObject(data);
    return this.httpService.post(`/v1/clients/page-posts/${id}`, formData).pipe(map((res) => PagePost.parse(res.data) as PagePost));
  }

  deletePost(id: number) {
    return this.httpService.delete(`/v1/clients/page-posts/${id}`);
  }

  reorderPosts(posts: { id: number; order: number }[]) {
    return this.httpService.post(`/v1/clients/page-posts-reorder`, { posts }).pipe(map((res) => PagePost.parse(res.data) as PagePost[]));
  }
}
